import React, { useEffect, useRef, useState } from "react";
import axios from "../../config/axios";
import { useCategories } from "../../Hooks/useProductsBySubCategory";
import styles from "./Search.module.scss";

//importing components
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Spin,
  message,
} from "antd";
import { HiChevronRight } from "react-icons/hi";
import { IoCloseOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../../Components/Layout/Layout";
import ProductCard from "../../Components/ProductCard/ProductCard";
import ProductSlider from "../../Components/Sliders/ProductSlider/ProductSlider";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import { MdCancel } from "react-icons/md";
import { BsArrowRight, BsSearch } from "react-icons/bs";
import Loader from "../../Components/Loader/Loader";
import { LoadingOutlined } from "@ant-design/icons";

const Search = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [resultCount, setResultCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(null);
  const [page, setPage] = useState(1);
  const [showMoreLoading, setShowMoreLoading] = useState(false);
  const [discountedProducts, setDiscountedProducts] = useState([]);
  const [limit, setLimit] = useState(18);
  const [sortBy, setSortBy] = useState("latest");

  // get recently viewed products from local storage
  const recentlyViewedProducts = window.localStorage.getItem("recentlyViewed")
    ? JSON.parse(window.localStorage.getItem("recentlyViewed"))
    : [];

  // desktop filter states
  const [desktopFilters, setDesktopFilters] = useState({
    promotion: [],
    category: [],
    selected_features: [],
    food_preference: [],
    allergens: [],
    free_from: [],
    nutri_score: [],
  });

  useEffect(() => {
    if (inputRef) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  useEffect(() => {
    if (!searchTerm) return;
    (async () => {
      try {
        if (page === 1) {
          setLoading(true);
        } else {
          setShowMoreLoading(true);
        }
        const response = await axios.get("/public/products", {
          withCredentials: false,
          params: {
            page: page,
            limit: 20,
            search_term: searchTerm,
          },
        });

        if (page > 1) {
          setProducts((products) => [...products, ...response.data.results]);
        } else {
          setProducts(response.data.results);
        }
        setResultCount(response.data.count);
      } catch (error) {
        message.info("No More Products Found");
      } finally {
        setLoading(false);
        setShowMoreLoading(false);
      }
    })();
  }, [page, searchTerm]);

  // some temp products for 2 slider
  useEffect(() => {
    // get discounted LandingV2
    (async () => {
      const res = await axios.get("/public/products?sub_category=7");
      setDiscountedProducts(res.data.results);
    })();
  }, []);

  let recent_terms = window.localStorage.getItem("recentSearches")
    ? JSON.parse(window.localStorage.getItem("recentSearches"))
    : [];

  // set search term on click
  const handleSearchTermClick = (term) => {
    setSearchTerm(term);
  };

  const location = useLocation();

  useEffect(() => {
    // get search term from url
    const urlParams = new URLSearchParams(location.search);
    const searchTerm = urlParams.get("searchTerm");
    if (searchTerm) {
      setSearchTerm(searchTerm);
      setPage(1);
    }
  }, [location]);

  return (
    <Layout>
      {/* mobile search */}
      <div className="d-block d-sm-none pt-4">
        <section className={styles.search}>
          <div>
            <div className={styles.search_box}>
              <div className={styles.search_box__wrapper}>
                <div className={styles.search_box__body}>
                  <img src="/icon/search.svg" alt="search" />
                  <Input
                    ref={inputRef}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);

                      // set recent searches of user stop typing for 3 seconds
                      setTimeout(() => {
                        if (e.target.value !== "") {
                          if (recent_terms.includes(e.target.value)) {
                            recent_terms.splice(
                              recent_terms.indexOf(e.target.value),
                              1,
                            );
                          }
                          recent_terms.unshift(e.target.value);

                          // limit recent searches to 12
                          if (recent_terms.length > 12) {
                            recent_terms.pop();
                          }

                          // remove duplicates
                          recent_terms = [...new Set(recent_terms)];
                          window.localStorage.setItem(
                            "recentSearches",
                            JSON.stringify(recent_terms),
                          );
                        }
                      }, 3000);
                    }}
                    value={searchTerm}
                    bordered={false}
                    placeholder={`I'm searching for`}
                  />
                  <img
                    style={{ height: "22px", width: "22px" }}
                    src="https://desi-fresh.b-cdn.net/components_static/scan_icon.svg"
                    alt="scan"
                  />
                </div>
                <IoCloseOutline onClick={() => setSearchTerm(null)} size={25} />
              </div>
            </div>
          </div>

          {searchTerm === "" || !searchTerm ? (
            <>
              <div className={styles.suggested_search}>
                <em>Suggested Searches</em>
                <ul>
                  <li
                    onClick={() =>
                      navigate("/category/discounts-offers-juc442_7")
                    }
                  >
                    <span>Discounts & Offers</span>
                    <HiChevronRight size={20} />
                  </li>
                  <li onClick={() => navigate("/category/staples-6E7B3D_10")}>
                    <span>Pickles & Condiments</span>
                    <HiChevronRight size={20} />
                  </li>
                  <li
                    onClick={() =>
                      navigate("/category/food-grains-oils-spices-3vdpnn_17")
                    }
                  >
                    <span>Food Grains, Oils & Spices</span>
                    <HiChevronRight size={20} />
                  </li>
                  <li
                    onClick={() =>
                      navigate("/category/spices-condiments-j2kcwu_12")
                    }
                  >
                    <span>Spices & Condiments</span>
                    <HiChevronRight size={20} />
                  </li>
                  <li
                    onClick={() =>
                      navigate("/category/pickles-sauces-canned-food-8902lB_18")
                    }
                  >
                    <span>Pickles, Sauces & Canned Food</span>
                    <HiChevronRight size={20} />
                  </li>
                  <li
                    onClick={() =>
                      navigate("/category/vegan-vegetarian-3hFwAh_27")
                    }
                  >
                    <span>Vegan & Vegetarian</span>
                    <HiChevronRight size={20} />
                  </li>
                </ul>
              </div>

              <div
                className={styles.recent}
                style={{
                  marginBottom: 300,
                }}
              >
                <em>Recent</em>
                <Row gutter={[10, 10]}>
                  {recent_terms.map((rt, index) => {
                    return (
                      <Col xs={6} key={index}>
                        <div
                          className={styles.recent__item}
                          onClick={() => handleSearchTermClick(rt)}
                        >
                          {rt}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </>
          ) : (
            <>
              {loading ? (
                <Loading />
              ) : (
                <>
                  {products.length > 0 ? (
                    <SearchResults
                      setPage={setPage}
                      term={searchTerm}
                      count={resultCount}
                      products={products}
                      showMoreLoading={showMoreLoading}
                    />
                  ) : (
                    <Empty term={searchTerm} />
                  )}
                </>
              )}

              {/* recommended product slider */}
              <Row style={{ margin: "1rem 0" }}>
                <Col lg={24} xs={24}>
                  <ProductSlider
                    showDiscountVariants
                    products={discountedProducts}
                    title="Discount & Offers"
                    link="/"
                  />
                </Col>
              </Row>

              {/* recently viewed slider */}
              {recentlyViewedProducts.length > 0 && (
                <Row style={{ margin: "1rem 0" }}>
                  <Col lg={24} xs={24}>
                    <ProductSlider
                      products={recentlyViewedProducts}
                      title="Recently Viewed"
                      link="/"
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        </section>
      </div>

      {/* desktop search */}
      <div className="d-none d-sm-block">
        <div className="container">
          <div className="mt-2">
            <BreadCrumb
              list={[
                {
                  name: "Back To Home",
                  link: "/",
                },
                {
                  name: "Search",
                  link: "/search",
                },
                {
                  name: searchTerm,
                  link: "/search",
                },
              ]}
            />
          </div>
          <br />
          <DesktopFilter
            desktopFilters={desktopFilters}
            setDesktopFilters={setDesktopFilters}
          />
          <br />
          <div className={styles.search_title}> {searchTerm} </div>
          <br />
          <Row>
            <Col lg={6} xs={0}>
              <div
                className={styles.products_number}
                style={{
                  marginTop: 5,
                }}
              >
                <div className={styles.prod_count}>
                  {resultCount} Articles in {searchTerm}
                </div>
              </div>
            </Col>
            <Col lg={15} offset={3} xs={0}>
              <Row gutter={[16, 16]}>
                <Col lg={11}>
                  <Input.Search
                    placeholder="Search Product"
                    onSearch={(value) => setSearchTerm(value)}
                    value={searchTerm}
                    enterButton={
                      <BsArrowRight
                        size={18}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      />
                    }
                    prefix={
                      <BsSearch
                        size={16}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          marginRight: 8,
                        }}
                      />
                    }
                  />
                </Col>
                <Col lg={7}>
                  <div className={styles.filter_products}>
                    <label htmlFor="articles">Number of products</label>
                    <Select
                      value={limit}
                      onChange={(value) => setLimit(value)}
                      style={{
                        width: 80,
                      }}
                    >
                      <Select.Option value={18}>18</Select.Option>
                      <Select.Option value={24}>24</Select.Option>
                      <Select.Option value={30}>30</Select.Option>
                    </Select>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className={styles.filter_products}>
                    <label htmlFor="articles">Sort by</label>
                    <Select
                      value={sortBy}
                      onChange={(value) => setSortBy(value)}
                    >
                      <Select.Option value="latest">Latest Items</Select.Option>
                      <Select.Option value="popular">
                        Most Popular
                      </Select.Option>
                    </Select>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />

          <div className={styles.main_products_area}>
            <Row>
              <Col lg={24} xs={24}>
                <Row gutter={[16, 16]} className={styles.products_wrapper}>
                  {loading ? (
                    <Loader height={"50vh"} />
                  ) : (
                    <>
                      {products?.length > 0 ? (
                        <>
                          {" "}
                          {products?.map((product, index) => (
                            <Col
                              lg={4}
                              xs={12}
                              className={styles.cat_products_grid}
                              key={index}
                            >
                              <ProductCard product={product} />
                            </Col>
                          ))}
                          <Col lg={24} xs={24}>
                            <div className={styles.pagination_center}>
                              {showMoreLoading ? (
                                <LoadingOutlined
                                  style={{
                                    fontSize: 30,
                                  }}
                                />
                              ) : (
                                <img
                                  onClick={() => {
                                    setPage((prev) => prev + 1);
                                  }}
                                  src="https://desi-fresh.b-cdn.net/misc/SeeMore.svg"
                                  alt="see_more"
                                  height={30}
                                  width={"100%"}
                                  loading="lazy"
                                  role="button"
                                />
                              )}
                            </div>
                          </Col>
                        </>
                      ) : (
                        <div className="d-flex w-100 justify-content-center">
                          <Empty term={searchTerm} />
                        </div>
                      )}
                    </>
                  )}
                </Row>
              </Col>
            </Row>

            <Divider />
            {/* recommended product slider */}
            <div>
              <ProductSlider
                showDiscountVariants
                products={discountedProducts}
                title="Discount & Offers"
                link="/"
              />
            </div>

            <Divider />
            {/* recently viewed slider */}
            {recentlyViewedProducts.length > 0 && (
              <Row style={{ margin: "1rem 0" }}>
                <Col lg={24} xs={24}>
                  <ProductSlider
                    products={recentlyViewedProducts}
                    title="Recently Viewed"
                    link="/"
                  />
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Search;

const Loading = () => {
  return (
    <div className={styles.loading}>
      <Spin />
    </div>
  );
};

const Empty = ({ term }) => {
  const { categories } = useCategories();
  const [count, setCount] = useState(6);
  return (
    <div className={styles.empty}>
      <div className={styles.empty_top}>
        <img
          src="https://desi-fresh.b-cdn.net/components_static/no-search-res.svg"
          alt="empty"
        />
        <p>
          Your search for <strong>“{term}”</strong> returned no result.
        </p>
        <p>Maybe we can help you with this?</p>
      </div>
      <Divider style={{ margin: "16px 0" }} />
      <h2 style={{ color: "var(--color-primary)" }}>Categories</h2>
      <div className={styles.categories}>
        {categories.slice(0, count).map((category, index) => (
          <Link to={`/category/${category.slug}`} key={index}>
            <div className={styles.subcategory_item} key={index}>
              <div className={styles.subcat_image_container}>
                <img src={category.image} alt={index} />
                <span>{category.name}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
      {categories.length > 0 && (
        <div className={styles.show_all_cat}>
          <div
            onClick={() => {
              setCount((prev) => (prev === 6 ? categories.length : 6));
            }}
          >
            Show all categories
          </div>
          <img
            src={
              count > 6
                ? "https://desi-fresh.b-cdn.net/components_static/chevron-up.svg"
                : "https://desi-fresh.b-cdn.net/components_static/chevron-down.svg"
            }
            alt="icon"
          />
        </div>
      )}
    </div>
  );
};

const SearchResults = ({ term, products, count, setPage, showMoreLoading }) => {
  return (
    <div className={styles.search_results}>
      <h3>
        Your search for “{term}” showed {count} results
      </h3>
      <Row gutter={[10, 10]}>
        {products.map((product, index) => (
          <Col xs={12} key={index}>
            <Link to={`/product/${product.slug}`} key={index}>
              <ProductCard product={product} />
            </Link>
          </Col>
        ))}
      </Row>

      {count > products.length && (
        <div className={styles.load_more}>
          <Button
            loading={showMoreLoading}
            disabled={showMoreLoading}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Load More
          </Button>
        </div>
      )}

      <Divider />
    </div>
  );
};

const DesktopFilter = ({ desktopFilters, setDesktopFilters }) => {
  const [filtersSelected, setFiltersSelected] = useState([]);
  useEffect(() => {
    let values = [];
    for (let key in desktopFilters) {
      values = [...values, ...desktopFilters[key]];
    }
    setFiltersSelected(values);

    console.log(desktopFilters);
  }, [desktopFilters]);

  const handleCrossBtnClick = (item) => {
    // remove the item from the selected filters
    const newFiltersSelected = filtersSelected.filter(
      (filter) => filter !== item,
    );
    setFiltersSelected(newFiltersSelected);

    // remove the item from the desktop filters also
    for (const key in desktopFilters) {
      if (desktopFilters.hasOwnProperty(key)) {
        const element = desktopFilters[key];
        if (element.includes(item)) {
          const newDesktopFilters = {
            ...desktopFilters,
            [key]: element.filter((filter) => filter !== item),
          };
          setDesktopFilters(newDesktopFilters);
        }
      }
    }
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Promotions
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    promotion: checkedValues,
                  }));
                }}
                value={desktopFilters.promotion}
              >
                <Row>
                  {[
                    {
                      label: "All Promotions",
                      value: "All Promotions",
                      amount: 50,
                    },
                    {
                      label: "Offers & discounts",
                      value: "Offers & discounts",
                      amount: 60,
                    },
                    {
                      label: "Go Halal Family offer",
                      value: "Go Halal Family offer",
                      amount: 40,
                    },
                    {
                      label: "Bio offers",
                      value: "Bio offers",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Category
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    category: checkedValues,
                  }));
                }}
                value={desktopFilters.category}
              >
                <Row>
                  {[
                    {
                      label: "Fruits & Vegetables",
                      value: "Fruits & Vegetables",
                      amount: 50,
                    },
                    {
                      label: "Dairy & Eggs",
                      value: "Dairy & Eggs",
                      amount: 60,
                    },
                    {
                      label: "Bread",
                      value: "Bread",
                      amount: 40,
                    },
                    {
                      label: "Bakery",
                      value: "Bakery",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Selected Features
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    selected_features: checkedValues,
                  }));
                }}
                value={desktopFilters.selected_features}
              >
                <Row>
                  {[
                    {
                      label: "Desi family",
                      value: "Desi family",
                      amount: 50,
                    },
                    {
                      label: "Asiafoodland",
                      value: "Asiafoodland",
                      amount: 60,
                    },
                    {
                      label: "Baladna",
                      value: "Baladna",
                      amount: 40,
                    },
                    {
                      label: "Feinkost Käfer",
                      value: "Feinkost Käfer",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Food Preferences
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    food_preference: checkedValues,
                  }));
                }}
                value={desktopFilters.food_preference}
              >
                <Row>
                  {[
                    {
                      label: "Vegan",
                      value: "Vegan",
                      amount: 50,
                    },
                    {
                      label: "Keto",
                      value: "Keto",
                      amount: 60,
                    },
                    {
                      label: "Bio",
                      value: "Bio",
                      amount: 40,
                    },
                    {
                      label: "Allergen free",
                      value: "Allergen free",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Allergen Free
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    allergens: checkedValues,
                  }));
                }}
                value={desktopFilters.allergens}
              >
                <Row>
                  {[
                    {
                      label: "Gluten Free",
                      value: "Gluten Free",
                      amount: 40,
                    },
                    {
                      label: "Lactose Free",
                      value: "Lactose Free",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Free From Additives
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    free_from: checkedValues,
                  }));
                }}
                value={desktopFilters.free_from}
              >
                <Row>
                  {[
                    {
                      label: "Preservative Free",
                      value: "Preservative Free",
                      amount: 50,
                    },
                    {
                      label: "No artificial color",
                      value: "No artificial color",
                      amount: 60,
                    },
                    {
                      label: "No added flavours",
                      value: "No added flavours",
                      amount: 40,
                    },
                    {
                      label: "No GMO",
                      value: "No GMO",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
        <Col flex={"14.28571428%"}>
          <Select
            style={{
              width: "100%",
            }}
            placeholder={
              <div
                style={{
                  color: "black",
                  fontWeight: "600",
                }}
              >
                Nutriscore
              </div>
            }
            className="custom_filter_select"
            dropdownRender={() => (
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(checkedValues) => {
                  setDesktopFilters((prev) => ({
                    ...prev,
                    nutri_score: checkedValues,
                  }));
                }}
                value={desktopFilters.nutri_score}
              >
                <Row>
                  {[
                    {
                      label: "A",
                      value: "A",
                      amount: 50,
                    },
                    {
                      label: "B",
                      value: "B",
                      amount: 60,
                    },
                    {
                      label: "C",
                      value: "C",
                      amount: 40,
                    },
                    {
                      label: "D",
                      value: "D",
                      amount: 30,
                    },
                    {
                      label: "E",
                      value: "E",
                      amount: 30,
                    },
                  ].map((item, index) => (
                    <Col span={24} key={index}>
                      <div className={styles.dt_filter_select}>
                        <Checkbox value={item.value}>{item.label}</Checkbox>
                        <div
                          style={{
                            color: "black",
                          }}
                        >
                          ({item.amount})
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {filtersSelected.length > 0 && (
            <div className={styles.desktop_filter_selected_items_wrapper}>
              {filtersSelected.map((item, index) => (
                <div
                  className={styles.desktop_filter_selected_items}
                  key={index}
                >
                  {item}
                  <MdCancel
                    size={18}
                    onClick={() => {
                      handleCrossBtnClick(item);
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};
